import { useContext, useEffect, useState } from "react";
import SocketContext from "../../../providers/Socket";
import { NotificationAudio } from "../../../audio";
import useConfig from "../../../hooks/use-config";
const Notification = (props) => {
    const { render } = props;
    const config = useConfig();
    const { socket } = useContext(SocketContext);
    const [counter, setCounter] = useState(0);
    useEffect(() => {
        if (!socket)
            return;
        socket === null || socket === void 0 ? void 0 : socket.on('timeline-notification', function () {
            NotificationAudio.getInstance().play();
            socket === null || socket === void 0 ? void 0 : socket.emit('get-stats');
        });
        socket.on('timeline-notification-update', function () {
            socket.emit('get-stats');
        });
        socket === null || socket === void 0 ? void 0 : socket.on('stats', function (data) {
            setCounter(data.unread);
        });
        socket === null || socket === void 0 ? void 0 : socket.emit('get-stats');
        return () => {
            socket === null || socket === void 0 ? void 0 : socket.off('timeline-notification');
            socket === null || socket === void 0 ? void 0 : socket.off('timeline-notification-update');
            socket === null || socket === void 0 ? void 0 : socket.off('stats');
        };
    }, [socket]);
    return render(counter);
};
export default Notification;
